import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  AbstractControl, NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {AddressComponent} from "../../../../shared/form-field/address/address.component";

@Component({
    selector: 'app-warehouse-address-detail',
    templateUrl: './warehouse-address-detail.component.html',
    styleUrls: ['./warehouse-address-detail.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => WarehouseAddressDetailComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => WarehouseAddressDetailComponent),
            multi: true
        }
    ],
    standalone: false
})
export class WarehouseAddressDetailComponent implements OnInit {
  // @ts-ignore
  @ViewChild(AddressComponent,{static: true}) addressComponent: AddressComponent;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() onInitForm = new EventEmitter<any>(true);
  public onModelValueChanged:any = {};

  public warehouseDetailForm: UntypedFormGroup = new UntypedFormGroup({
    main_address: new UntypedFormControl(null),
  });

  constructor() { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    this.onModelValueChanged = this.model.model;

  }

  ngOnInit(): void {
  }
  initChildForm(value: any){
    this.warehouseDetailForm.get('main_address')?.setValue(value);
    this.onInitForm.emit(this.warehouseDetailForm);
  }
  initFormControlValues(value: any){
    if (value){
      this.warehouseDetailForm.get('main_address')?.setValue(this.addressComponent.initFormControlValues(value));
    }
    return this.warehouseDetailForm;
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.warehouseDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.warehouseDetailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.warehouseDetailForm.disable() : this.warehouseDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.warehouseDetailForm.valid ? null : { invalidForm: {valid: false, message: "Warehouse detail fields are invalid"}};
  }

}
